import {
	GET_ALL_RELATED_DOCUMENTS_FOR_SAMPLE,
	DELETE_DOCUMENT_FROM_SAMPLE_ITEM,
	CLEAR_SAMPLE_RELATED_DOCUMENTS,
	UPDATE_DOCUMENT,
	DELETE_DOCUMENT_BY_ID,
	RELATE_SAMPLE_ITEM_DOCUMENT,
	POST_RNH_NEW_NOTE,
	UPDATE_RNH_NOTE_DETAIL
} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {isApiResponseOk} from '../../util/utils';
import {updateAnnotationAction} from '../../util/uiconstants';

export default function sampleItemDocumentReducer(state = initialstate.sampleItemDocuments, action) {
	const viewKeys = ['SAMPLE_ITEM_evidence', 'SAMPLE_ITEM_temporary', 'SAMPLE_ITEM_external'];
	switch (action.type) {
		case GET_ALL_RELATED_DOCUMENTS_FOR_SAMPLE:
			return {...state, [action.parentName]: action.response};
		case CLEAR_SAMPLE_RELATED_DOCUMENTS:
			return initialstate.sampleItemDocuments;
		case DELETE_DOCUMENT_FROM_SAMPLE_ITEM:
			if (isApiResponseOk(action)) {
				const parentData = state[action.parentName];
				return {
					...state,
					[action.parentName]: {
						...parentData,
						totalEntityCount: parentData.totalEntityCount - 1,
						data: parentData.data.filter((document) => {
							return !(document.id === action.documentId);
						})
					}
				};
			} else return state;
		case RELATE_SAMPLE_ITEM_DOCUMENT:
			if (isApiResponseOk(action)) {
				const parentData = state[action.parentName];
				return {
					...state,
					[action.parentName]: {
						...parentData,
						totalEntityCount: parentData.totalEntityCount + 1,
						data: [...parentData.data, {id: action.documentId}]
					}
				};
			} else return state;
		case UPDATE_DOCUMENT:
			if (viewKeys.includes(action.viewKey)) {
				const viewParentName = getViewParentName(action.viewKey);
				const updatedDocumentIndex = findDocumentIndex(state, viewParentName, action.documentId);

				let updatedDocument = _.cloneDeep(state[viewParentName].data[updatedDocumentIndex]);
				updatedDocument = {...updatedDocument, ...action.meta.api.data};

				const newData = [...state[viewParentName].data];
				newData[updatedDocumentIndex] = updatedDocument;

				return {
					...state,
					[viewParentName]: {
						...state[viewParentName],
						data: newData
					}
				};
			}
			return state;
		case DELETE_DOCUMENT_BY_ID:
			if (viewKeys.includes(action.viewKey)) {
				const viewParentName = getViewParentName(action.viewKey);
				const parentData = state[viewParentName];
				const updatedData = parentData.data.filter((document) => document.id !== action.documentId);
				return {
					...state,
					[viewParentName]: {
						...parentData,
						data: updatedData,
						totalEntityCount: parentData.totalEntityCount - 1
					}
				};
			}
			return state;
		case POST_RNH_NEW_NOTE:
			if (isApiResponseOk(action) && viewKeys.includes(action.noteInfo?.viewKey)) {
				const {documentId} = action.meta.api.data;
				const viewParentName = getViewParentName(action.noteInfo?.viewKey);
				const updatedDocumentIndex = findDocumentIndex(state, viewParentName, documentId);
				let updatedDocument = _.cloneDeep(state[viewParentName].data[updatedDocumentIndex]);
				updatedDocument = {
					...updatedDocument,
					engagementReviewNoteCount: updatedDocument.engagementReviewNoteCount + 1
				};
				const newData = [...state[viewParentName].data];
				newData[updatedDocumentIndex] = updatedDocument;

				return {
					...state,
					[viewParentName]: {
						...state[viewParentName],
						data: newData
					}
				};
			}
			return state;
		case UPDATE_RNH_NOTE_DETAIL:
			if (isApiResponseOk(action) && viewKeys.includes(action.commentData?.viewKey)) {
				const {updateAction} = action.data;
				if (updateAction === updateAnnotationAction.bulkStatusUpdate) {
					const {documentId, statusIdChanged, isOpening} = action.data;
					const viewParentName = getViewParentName(action.commentData?.viewKey);
					const updatedDocumentIndex = findDocumentIndex(state, viewParentName, documentId);
					let updatedDocument = _.cloneDeep(state[viewParentName].data[updatedDocumentIndex]);
					if (statusIdChanged && isOpening) {
						updatedDocument = {
							...updatedDocument,
							engagementReviewNoteCount: updatedDocument.engagementReviewNoteCount + 1
						};
					} else {
						updatedDocument = {
							...updatedDocument,
							engagementReviewNoteCount: updatedDocument.engagementReviewNoteCount - 1
						};
					}
					const newData = [...state[viewParentName].data];
					newData[updatedDocumentIndex] = updatedDocument;

					return {
						...state,
						[viewParentName]: {
							...state[viewParentName],
							data: newData
						}
					};
				}
			}
			return state;
		default:
			return state;
	}
}

function getViewParentName(viewKey){
	return viewKey.replace('SAMPLE_ITEM_', '');
}

function findDocumentIndex(state, viewParentName, documentId) {
	return state[viewParentName].data.findIndex(document => document.id === documentId);
}
